(() => {
  // Judge.me localizes its visible controls; these accessibility labels remain English.
  // Restrict changes to known widget labels and never touch customer review content.
  let scheduled = false;
  const exact = {
    'Customer reviews': 'review_customer_reviews',
    'Sort reviews by': 'review_sort',
    'Loading thumbnail': 'review_loading_thumbnail',
    'Thumbnail Navigation': 'review_thumbnail_navigation',
    'Close review form': 'review_form_close',
    'Review form pages': 'review_form_pages',
    'Rating': 'review_rating',
    'Review Image': 'review_image',
    'Privacy and Terms': 'review_privacy_terms',
    'Review form navigation': 'review_navigation',
    'Previous step': 'review_previous',
    'Next step': 'review_next',
  };
  function translated(value) {
    const copy = window.RenlyUI;
    if (!copy) return value;
    if (exact[value]) return copy[exact[value]] || value;
    if (value === '1 star' && copy.review_star_one) return copy.review_star_one.replace('{count}', '1');
    const patterns = [
      [/^([\d.]+) out of 5 stars$/, 'review_stars'],
      [/^Thumbnails for (\d+) items$/, 'review_thumbnails'],
      [/^Go to item (\d+)$/, 'review_go_item'],
      [/^(\d+) stars?$/, 'review_star_count'],
    ];
    for (const [pattern, key] of patterns) {
      const match = value.match(pattern);
      if (match && copy[key]) return copy[key].replace('{count}', match[1]);
    }
    return value;
  }
  function update() {
    scheduled = false;
    document.querySelectorAll('.jdgm-widget, .jdgm-write-review-modal').forEach(widget => {
      widget.querySelectorAll('[aria-label], [title], img[alt]').forEach(element => {
        for (const name of ['aria-label', 'title', 'alt']) {
          const value = element.getAttribute(name);
          if (!value) continue;
          const next = translated(value);
          if (next !== value) element.setAttribute(name, next);
        }
      });
      widget.querySelectorAll('label.jdgm-visually-hidden').forEach(label => {
        if (label.textContent.trim() === 'Sort reviews by') label.textContent = translated('Sort reviews by');
      });
      widget.querySelectorAll('.jm-media-grid > .sr-only').forEach(label => {
        if (label.textContent.trim() === 'Thumbnail Navigation') label.textContent = translated('Thumbnail Navigation');
      });
      widget.querySelectorAll('.jdgm-write-review-modal__nav-btn-close').forEach(button => {
        if (button.textContent.trim() === 'Schließen' && window.RenlyUI?.dialog_close) button.textContent = window.RenlyUI.dialog_close;
      });
      widget.querySelectorAll('.jdgm-write-review-modal__stars').forEach(stars => {
        if (window.RenlyUI?.review_rating_best) stars.style.setProperty('--renly-review-rating-best', JSON.stringify(window.RenlyUI.review_rating_best));
      });
      widget.querySelectorAll('#jdgm-email-help').forEach(help => {
        if (help.textContent.trim() === 'Vi respekterer din personvern.' && window.RenlyUI?.review_privacy_help) help.textContent = window.RenlyUI.review_privacy_help;
      });
      widget.querySelectorAll('label[for="yt_url"]').forEach(label => {
        if (label.textContent.trim() === 'YouTube URL' && window.RenlyUI?.review_video_url) label.textContent = window.RenlyUI.review_video_url;
      });
      widget.querySelectorAll('.jm-sort-filter > .jdgm-visually-hidden[role="status"]').forEach(status => {
        const value = status.textContent.trim();
        if (value.startsWith('Sorted by ') && window.RenlyUI?.review_sorted) status.textContent = window.RenlyUI.review_sorted.replace('{sort}', value.slice(10));
      });
      // Judge.me can retain an old catalog image after the main gallery changes.
      const cover = document.querySelector('[data-renly-root] [data-gallery] [data-slide="0"] img');
      const coverSrc = cover?.getAttribute('src');
      if (coverSrc) widget.querySelectorAll('.jdgm-write-review-modal__product-image img').forEach(image => {
        if (image.getAttribute('src') !== coverSrc) image.setAttribute('src', coverSrc);
        if (image.alt !== cover.alt) image.alt = cover.alt;
      });
    });
    document.querySelectorAll('#shopify-pc__prefs [aria-label="Close dialog"]').forEach(button => {
      if (window.RenlyUI?.dialog_close) button.setAttribute('aria-label', window.RenlyUI.dialog_close);
    });
  }
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  });
  observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-label', 'title', 'alt', 'src'] });
  update();
})();
